// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-menu-items a {
  border-left: 10px solid transparent !important;
  border-radius: 10px !important;
}
.sidebar-menu-items .active {
  border-left: 10px solid #ff8908 !important;
  border-radius: 10px !important;
}
.sidebar-menu-items .active .sidebar-menu-title {
  color: #ff611d !important;
  font-weight: 600 !important;
}
.sidebar-menu-items .active img {
  filter: brightness(0) saturate(100%) invert(44%) sepia(58%) saturate(598%) hue-rotate(175deg) brightness(85%) contrast(99%);
}

.mui-icon-button-container-hover:hover {
  background-color: #ff611d !important;
}
.mui-icon-button-container-hover:hover .mui-icon-button-icon {
  color: #ffffff !important;
}

.close-modal-hover:hover {
  background-color: #333333 !important;
  color: #ffffff !important;
}

.modal-transform-center {
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.scss"],"names":[],"mappings":"AAGE;EACE,8CAAA;EACA,8BAAA;AAAJ;AAGE;EACE,0CAAA;EACA,8BAAA;AADJ;AAGI;EACE,yBAAA;EACA,2BAAA;AADN;AAII;EACE,2HAAA;AAFN;;AAOA;EACE,oCAAA;AAJF;AAME;EACE,yBAAA;AAJJ;;AASE;EACE,oCAAA;EACA,yBAAA;AANJ;;AAUA;EACE,gCAAA;EACA,QAAA;EACA,SAAA;AAPF","sourcesContent":["@import \"./variables\";\n\n.sidebar-menu-items {\n  & a {\n    border-left: 10px solid transparent !important;\n    border-radius: 10px !important;\n  }\n\n  & .active {\n    border-left: 10px solid $orange-color !important;\n    border-radius: 10px !important;\n\n    & .sidebar-menu-title {\n      color: $primary-color !important;\n      font-weight: $font-weight-600 !important;\n    }\n\n    & img {\n      filter: brightness(0) saturate(100%) invert(44%) sepia(58%) saturate(598%) hue-rotate(175deg) brightness(85%) contrast(99%);\n    }\n  }\n}\n\n.mui-icon-button-container-hover:hover {\n  background-color: $primary-color !important;\n\n  & .mui-icon-button-icon {\n    color: $white-color !important\n  }\n}\n\n.close-modal-hover {\n  &:hover {\n    background-color: $secondary-color !important;\n    color: $white-color !important;\n  }\n}\n\n.modal-transform-center {\n  transform: translate(-50%, -50%);\n  top: 50%;\n  left: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
